import { msalInstance } from "@config/auth/msalConfig";
import {
	queryOptions,
	useMutation,
	useQuery,
	useSuspenseQuery,
} from "@tanstack/react-query";
import { changePassword, getUser, revokeAllUserSessions } from "./api";

export const userQueryOptions = () =>
	queryOptions({
		queryKey: ["userQuery"],
		queryFn: () => getUser(),
	});

export function useUser() {
	return useQuery(userQueryOptions());
}

export function useUserSuspense() {
	return useSuspenseQuery(userQueryOptions());
}

export function useRevokeAllUserSessionsMutation() {
	return useMutation({
		mutationFn: async ({ signOutHere }: { signOutHere: boolean }) => {
			await revokeAllUserSessions();

			if (signOutHere) {
				await msalInstance.logoutRedirect({
					postLogoutRedirectUri: "/sign-in",
				});
			}
		},
	});
}

export function useChangePasswordMutation() {
	return useMutation({
		mutationFn: ({
			currentPassword,
			newPassword,
		}: {
			currentPassword: string;
			newPassword: string;
		}) => changePassword(currentPassword, newPassword),
	});
}
